import { render, staticRenderFns } from "./card_record.vue?vue&type=template&id=24c66926&scoped=true"
import script from "./card_record.vue?vue&type=script&lang=js"
export * from "./card_record.vue?vue&type=script&lang=js"
import style0 from "./card_record.vue?vue&type=style&index=0&id=24c66926&prod&scoped=true&lang=css"
import style1 from "./card_record.vue?vue&type=style&index=1&id=24c66926&prod&lang=css"
import style2 from "./card_record.vue?vue&type=style&index=2&id=24c66926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c66926",
  null
  
)

export default component.exports